import * as t from 'io-ts';

import type { CheckBoxDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface ApplyFilterOnExactDrillOnlyDefinition extends CheckBoxDefinition {
    key: 'APPLY_FILTER_ON_EXACT_DRILL_ONLY';
}

const definition: ApplyFilterOnExactDrillOnlyDefinition = {
    key: 'APPLY_FILTER_ON_EXACT_DRILL_ONLY',
    type: 'CheckBox',
    label: 'Only emit filter for exact drill',
    value: false,
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.boolean);

export const codec = specSettingsInterface.input;

export const ApplyFilterOnExactDrillOnlyDefinition = define({
    key: 'APPLY_FILTER_ON_EXACT_DRILL_ONLY',
    label: 'emitFilterOnExactDrill',
    definition,
    fromSetting: (settings, _, _view) =>
        specSettingsInterface.extractValue(settings.emitFilterOnExactDrill),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.emitFilterOnExactDrill),
});
